export default "__VITE_ASSET__aafb22ce__"